import type { ReactNode } from 'react';
import { VisuallyHidden } from 'radix-ui';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@reflex/ui/components/ui/sheet';

interface MobileIdentitySheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Editable run title. */
  title: ReactNode;
  /** Identity chips (repo, branch, PR, labels, …). */
  details?: ReactNode;
}

/**
 * Bottom sheet for the truncated mobile header: full title (rename) and the
 * identity tags that sit beside the title on desktop. Distinct from the
 * Details tool, which opens the full agent detail panel.
 */
export function MobileIdentitySheet({
  open,
  onOpenChange,
  title,
  details,
}: MobileIdentitySheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        showCloseButton
        className="gap-0 rounded-t-xl p-0 sm:max-w-none"
        data-testid="mobile-identity-sheet"
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <SheetHeader className="px-4 py-3 text-left">
          <VisuallyHidden.Root>
            <SheetTitle>Title and tags</SheetTitle>
          </VisuallyHidden.Root>
          <div className="min-w-0 pr-8 text-sm font-semibold leading-snug text-foreground">
            {title}
          </div>
          {details ? <div className="pt-3">{details}</div> : null}
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
}
